import { createPage, removePage, updatePage } from '../page/utils.js';
const applyPageUpdate = async (state, pageId, pageData) => {
    if (pageData === null) {
        return removePage(state, pageId);
    }
    const existingPageFolder = state.pages.getFolderPath(pageId);
    if (existingPageFolder) {
        return updatePage(state, pageId, existingPageFolder, pageData);
    }
    return createPage(state, pageId, pageData);
};
export const applyDocumentExternalUpdates = async (state, { pages }) => {
    for (const [pageId, pageData] of Object.entries(pages)) {
        await applyPageUpdate(state, pageId, pageData);
    }
};
